import Axios from './axios'

export default {
  getServiceArea: (serviceAreaId, token) => {
    const axios = Axios.setup(serviceAreaId, token)

    return new Promise((resolve) => {
      axios.get(`serviceAreas/${serviceAreaId}`)
        .then(payload => {
          resolve(payload.data)
        })
    })
  }
}
